export const siteConfig = {
  siteTitle: "Anil Maharjan", // Site title.
  siteTitleShort: "Anil's blog", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "Web technology and more", // Alternative site title for SEO.
  siteLogo: "/icons/icon-512x512.png", // Logo used for SEO and manifest.
  siteUrl: "https://anilmaharjan.com.np", // Domain of your website without pathPrefix.
  pathPrefix: "", // Prefixes all links. For cases when deployed to example.github.io/gatsby-material-starter/.
  fixedFooter: false, // Whether the footer component is fixed, i.e. always visible
  siteDescription:
    "Anil shares stuffs around web development and his hobby projects on his blog.", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  siteFBAppID: "1825356251115265", // FB Application ID for using app insights
  gtmId: "GTM-TDRFG7X",
  siteGATrackingID: "UA-47311644-4", // Tracking code ID for google analytics.
  disqusShortname: "anilmaharjan-com-np", // Disqus shortname.
  postDefaultCategoryID: "Tech", // Default category for posts.
  dateFromFormat: "YYYY-MM-DD", // Date format used in the frontmatter.
  dateFormat: "DD/MM/YYYY", // Date format for display.
  userName: "Anil Maharjan", // Username to display in the author segment.
  userEmail: "anil@anilmaharjan.com.np", // Email used for RSS feed's author segment
  userTwitter: "dejavu1987", // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: "Berlin, Germany", // User location to display in the author segment.
  userAvatar:
    "https://en.gravatar.com/userimage/114904533/7b89c93fcb53019706c2c6843191d1e1.jpg?size=300", // User avatar to display in the author segment.
  userDescription: "Front end web developer, curious about everything else.", // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: "GitHub",
      url: "https://github.com/dejavu1987",
      iconClassName: "fa fa-github",
    },
    {
      label: "Twitter",
      url: "https://twitter.com/dejavu1987",
      iconClassName: "fa fa-twitter",
    },
  ],
  copyright: "Copyright © 2019 Anil Maharjan", // Copyright string for the footer of the website and RSS feed.
};

// Validate

// Make sure pathPrefix is empty if not needed
if (siteConfig.pathPrefix === "/") {
  siteConfig.pathPrefix = "";
} else {
  // Make sure pathPrefix only contains the first forward slash
  siteConfig.pathPrefix = `/${siteConfig.pathPrefix.replace(/^\/|\/$/g, "")}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (siteConfig.siteUrl.substr(-1) === "/")
  siteConfig.siteUrl = siteConfig.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
if (siteConfig.siteRss && siteConfig.siteRss[0] !== "/")
  siteConfig.siteRss = `/${siteConfig.siteRss}`;
